(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-tys-home]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('.te-mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const menu = root.querySelector('.te-mobile-nav[open]');
        if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
